<p>loading-indicator works!</p>
